module.exports = __webpack_public_path__ + "dscout-private-panels-og-image.jpg";